module.exports = __webpack_public_path__ + "static/img/pro-6.69287da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/pro-6.png
// module id = tIUn
// module chunks = 1